import { Box, Typography, Stack } from '@mui/material'
import { ReactNode } from 'react'
import { SECTION_TINTS, INK_MUTED } from '../palette'

interface Props {
  number?: number
  title: string
  description?: string
  children: ReactNode
  id?: string
  accentColor?: string
}

export default function SectionContainer({
  number,
  title,
  description,
  children,
  id,
  accentColor,
}: Props) {
  const bg = id ? SECTION_TINTS[id] : undefined

  return (
    <Box
      id={id}
      sx={{
        scrollMarginTop: 80,
        background: bg && bg !== 'transparent' ? bg : 'transparent',
        // Slight negative margin + padding so the tint bleeds full width of
        // the editorial column without the content losing alignment
        mx: bg && bg !== 'transparent' ? { xs: -2, sm: -3, md: -6 } : 0,
        px: bg && bg !== 'transparent' ? { xs: 2, sm: 3, md: 6 } : 0,
        py: { xs: 6, md: 10 },
      }}
    >
      <Stack spacing={4}>
        <Stack spacing={1}>
          {typeof number === 'number' && (
            <Typography
              variant="overline"
              sx={{
                color: accentColor || INK_MUTED,
                letterSpacing: 3,
                fontSize: 11,
                fontWeight: 600,
              }}
            >
              SECTION {String(number).padStart(2, '0')}
            </Typography>
          )}
          <Typography
            sx={{
              fontFamily: 'var(--ns-display-font)',
              fontWeight: 500,
              fontSize: { xs: 28, md: 40 },
              letterSpacing: '-0.01em',
              lineHeight: 1.1,
            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 720 }}>
              {description}
            </Typography>
          )}
        </Stack>
        <Box>{children}</Box>
      </Stack>
    </Box>
  )
}
